import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';

export const OOS_LOG_FILTER_QUERY_KEYS = Object.freeze({
    COMPANY_SOURCES: 'companySources',
});

export const externalSkuFilterConfig = {
    key: 'externalSku',
    label: 'External SKU',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter external SKU…',
    },
};

export const companySourceFilterConfig = {
    key: 'companySourceIds',
    label: 'Company Source',
    type: FilterType.SELECT,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: OOS_LOG_FILTER_QUERY_KEYS.COMPANY_SOURCES,
    },
    menuProps: {
        placeholder: 'Select company sources…',
        mergeWithStaticOptions: false,
    },
};

export const packLineFilterConfig = {
    key: 'packLineNumber',
    label: 'Pack Line',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Pack line number, or “unslotted”…',
    },
};

export const authUserFilterConfig = {
    key: 'authUser',
    label: 'User',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter user email…',
    },
};

export const timestampRangeFilterConfig = {
    key: 'timestampRange',
    label: 'Date',
    type: FilterType.DATE_RANGE,
    deletable: true,
};

export const OosLogFilterConfigArray = [
    externalSkuFilterConfig,
    companySourceFilterConfig,
    packLineFilterConfig,
    authUserFilterConfig,
    timestampRangeFilterConfig,
];
